export enum ShowAddressOption {
    full,
    street
}